const Registration = {

    // PAGE HEADER
    "participant": "प्रतिभागी",
    "organizer": "आयोजक",
    "participant_header": "प्रतिभागी पंजीकरण",
    "organizer_header": "आयोजक पंजीकरण",

    // FIELDS
    'title': 'शीर्षक',
    'f_name': 'पहला नाम',
    'm_name': 'मध्य नाम',
    'l_name': 'अंतिम नाम',
    'user_name': 'यूज़र नाम',
    'email': 'ईमेल',
    'password': 'पासवर्ड',
    'phone': 'फोन',
    'gender': 'लिंग',
    'alternate_phone': 'वैकल्पिक फोन (सोशल)',
    'emergency_phone': 'आपातकालीन फोन',
    'emergency_phone_relative': 'आपातकालीन फोन (रिश्तेदार)',
    'dob': 'जन्म तिथि',
    'established_date': 'स्थापना तिथि',
    'blood_group': 'ब्लड ग्रुप',
    'country': 'देश',
    'state': 'राज्य',
    'city': 'शहर',
    'pincode': 'पिनकोड',
    'profile_photo': 'प्रोफ़ाइल फोटो (केवल .jpeg, .jpg, .png स्वीकार्य)',
    'address': 'पता',
    'shoe_size': 'जूते का आकार',
    'tshirt_size': 'टी-शर्ट का आकार',
    'aadhar_no': 'आधार नंबर',
    'upload_aadhar': 'आधार अपलोड करें (केवल .jpeg, .jpg, .png, .pdf स्वीकार्य)',
    'pan_no': 'पैन नंबर',
    'upload_pan': 'पैन अपलोड करें (केवल .jpeg, .jpg, .png, .pdf स्वीकार्य)',
    'gst_no': 'जीएसटी नंबर',
    'upload_gst': 'GST अपलोड करें (केवल .jpeg, .jpg, .png, .pdf स्वीकार्य)',
    'organization_name': 'संगठन का नाम',
    'organization_type': 'संगठन का प्रकार',
    'organization_details': 'संगठन विवरण',
    'organizer_details': 'आयोजक विवरण',
    'documents': 'दस्तावेज़',

    // FOOTER
    "footer_tagline": "क्या आपके पास पहले से खाता है?",
    "back_to_login": "लॉगिन पर वापस जाएँ",

    // TOAST
    "success_add": "सफलतापूर्वक पंजीकरण हुआ!!..",
    "success_add_organizer": "आपका आयोजक प्रोफ़ाइल बनाने के लिए धन्यवाद! हम आपके विवरण की समीक्षा कर रहे हैं और इसे 24 घंटे या एक कार्य दिवस के भीतर अनुमोदित कर देंगे।",
    "success_upload": "फ़ाइल सफलतापूर्वक अपलोड हो गई!!..",
    "success_google": "Google से साइन इन सफल! कृपया बाकी आवश्यक विवरण भरें",
    "failed_google": "Google साइन-इन विफल रहा",
    "server_error": "सर्वर त्रुटि!!..",
    "wrong": "कुछ गलत हो गया!!..",

    // ERROR
    'error_title': 'कृपया शीर्षक दर्ज करें',
    'error_f_name': 'कृपया पहला नाम दर्ज करें',
    'error_m_name': 'कृपया मध्य नाम दर्ज करें',
    'error_l_name': 'कृपया अंतिम नाम दर्ज करें',
    'error_user_name': 'कृपया यूज़र नाम दर्ज करें',
    'error_email': 'कृपया ईमेल दर्ज करें',
    'error_password': 'कृपया पासवर्ड दर्ज करें',
    'error_phone': 'कृपया फोन नंबर दर्ज करें',
    'error_gender': 'कृपया लिंग चुनें',
    'error_alternate_phone': 'कृपया वैकल्पिक फोन दर्ज करें (सोशल)',
    'error_emergency_phone': 'कृपया आपातकालीन फोन दर्ज करें',
    'error_emergency_phone_relative': 'कृपया आपातकालीन फोन (रिश्तेदार) दर्ज करें',
    'error_dob': 'कृपया जन्म तिथि चुनें',
    'error_established_date': 'स्थापना तिथि चुनें',
    'error_blood_group': 'कृपया ब्लड ग्रुप चुनें',
    'error_country': 'कृपया देश चुनें',
    'error_state': 'कृपया राज्य चुनें',
    'error_city': 'कृपया शहर चुनें',
    'error_pincode': 'कृपया पिनकोड दर्ज करें',
    'error_profile_photo': 'कृपया प्रोफ़ाइल फ़ोटो चुनें',
    'error_address': 'कृपया पता दर्ज करें',
    'error_shoe_size': 'कृपया जूते का आकार चुनें',
    'error_tshirt_size': 'कृपया टी-शर्ट का आकार चुनें',
    'error_aadhar_no': 'कृपया आधार नंबर दर्ज करें',
    'error_upload_aadhar': 'कृपया आधार दस्तावेज़ चुनें',
    'error_pan_no': 'कृपया पैन नंबर दर्ज करें',
    'error_upload_pan': 'कृपया पैन दस्तावेज़ चुनें',
    'error_gst_no': 'कृपया जीएसटी नंबर दर्ज करें',
    'error_upload_gst': 'कृपया जीएसटी दस्तावेज़ चुनें',
    'error_organization_name': 'कृपया संगठन का नाम दर्ज करें',
    'error_organization_type': 'कृपया संगठन का प्रकार चुनें',

    'error_invalid_phone': 'अवैध फोन नंबर',
    'error_18_year': 'आपकी आयु कम से कम 18 वर्ष होनी चाहिए',

}

export default Registration;